export default __webpack_public_path__ + "static/media/fushimi_inari_shrine.77c49aa2.jpeg";